import { createRoutine } from '../common/utils/routines.js';

export const getProjectWebhooks = createRoutine('webhooks/GET_PROJECT_WEBHOOKS');
export const updateProjectWebhooks = createRoutine('webhooks/UPDATE_PROJECT_WEBHOOKS');
